var map = {
	"./default_avatar_0.png": 236,
	"./default_avatar_1.png": 237,
	"./default_avatar_10.png": 238,
	"./default_avatar_11.png": 239,
	"./default_avatar_12.png": 240,
	"./default_avatar_13.png": 241,
	"./default_avatar_14.png": 242,
	"./default_avatar_15.png": 243,
	"./default_avatar_16.png": 244,
	"./default_avatar_17.png": 245,
	"./default_avatar_2.png": 246,
	"./default_avatar_3.png": 247,
	"./default_avatar_4.png": 248,
	"./default_avatar_5.png": 249,
	"./default_avatar_6.png": 250,
	"./default_avatar_7.png": 251,
	"./default_avatar_8.png": 252,
	"./default_avatar_9.png": 253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;